import { render } from "./AdminProfileView.vue?vue&type=template&id=33cbbb06"
import script from "./AdminProfileView.vue?vue&type=script&lang=js"
export * from "./AdminProfileView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__